<!-- eslint-disable -->
<template lang="pug">
    .play-box(class="play-box_limited")
        template(v-if="!isLoading")
            game-header(
                v-if="!isBattle"
                @soundStateChanged="headerKey = !headerKey",
                :key="headerKey",
                :time='getTime'
                :slug="type"
                :game-type="parameters && parameters.courseType"
                :is-homework="!!exerciseId"
            )
            .play-box__game(v-if='gameStarted && !gameFinished')
                .play-box__example
                    scaling-bar(v-model="fontSizeCoefficient")
                    div
                        .play-box__field
                            .play-box__field-chunk(v-for="(chunk, indexChunk) in chunkedTextArray" :style="{'fontSize': fontSizeCoefficient + 'em'}")
                                template(v-for="(item, indexItem) in chunk")
                                    div(v-if="item.type === 'word'" v-html="getUserAnswerWord(item, indexChunk * 2 + indexItem)")
                                    .play-box__field-space(v-else v-html="item.showAnswer ? item.answer : item.userAnswer" :class="spaceClass(item)" @click="clickSpace(item)")
                                    
                        .play-box__marks
                            .play-box__mark(
                                v-for="(item, index) in ALL_MARKS" 
                                :key="`mark_${index}`" 
                                :class=`{
                                    'selected': selectedPunctuationMark === item, 
                                    'play-box__mark-padding': [',', '.'].includes(item)
                                }`
                                :style="{'fontSize': fontSizeCoefficient + 'em'}"
                                @click="selectedPunctuationMark = item"
                            )
                                span.play-box__mark-text(v-html="item")

                        .play-box__answer-buttons
                            cs-button.answer-button(
                                :disabled="textArray.some(item => item.showAnswer) || !canClickReply"
                                color="blue",
                                pattern="primary-outline",
                                type='button',
                                @click='processReply()',
                            )
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_check') }}
                            cs-button.answer-button(
                                v-if="!showAnswer && !isOlympiad && !isBattle"
                                :disabled="canClickReply",
                                color="blue",
                                pattern="primary-outline",
                                type='button',
                                @click='processFix',
                            )
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_fix') }}
                            cs-button.answer-button(
                                v-else
                                color="blue",
                                pattern="primary-outline",
                                type='button',
                                @click='finishGame',
                            )
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_further') }}
                        .play-box__answer-buttons(v-if="amountClickAnswer >= 3 && parameters.showingCorrectAnswers")
                            cs-button.answer-button(
                                color="blue",
                                pattern="primary-outline",
                                type='button',
                                @click='showCorrectAnswers',
                            )
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_showingCorrectAnswers') }}
                .game-info__block
                    game-info(
                        :score="{left: answers.good, right: answers.bad}"
                        :time="getTime"
                        :slug="type"
                        :parameters="parameters"
                        :game-allows-tips="false"
                        :opponent="opponent"
                        :opponent-numbers="opponentNumbers"
                        :is-opponent-answering="isOpponentAnswering"
                        :is-from-battle="isBattle"
                        :is-olympiad="isOlympiad"
                    )
            .play-box__end-container(v-if='gameFinished && !isOlympiad')
                    fireworks(:is-mobile="isMobile")
                    .play-box__reaction-container
                        .play-box__answers.play-box__answers--left
                            | {{ $i18n.t('trainer.trainer_game_wordField_yourTime') }}
                            br
                            | {{ getTime }}
                        result-image.play-box__image(status="success")
                        .play-box__answers.play-box__answers--right
                            | {{ $i18n.t('dashboard.dashboard_sidebar_statistics') }}
                            br
                            | {{ answers.good }} / {{ answers.bad }}
                    result-buttons(
                        v-if="!isBattle"
                        :exercise-id="exerciseId"
                        :games-type="parameters.courseType"
                        show-restart-button
                        @restartGame="restartGame"
                    )
                        slot
            calculating-answers(v-if="calculatingAnswers" :is-last-game-in-battle="isLastGameInBattle")
        cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import { cloneDeep, chunk } from 'lodash';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import Battle from '../../../../utils/battle/battleMixin';
    import olympiadRussianLanguageAnswerTimerMixin from '../../../../utils/olympiads/olympiadRussianLanguageAnswerTimerMixin.js';
    import ScalingBar from './ScalingBar.vue';
    import CalculatingAnswers from '../../CalculatingAnswersModal.vue';

    const SPACE = '&nbsp;';
    const PUNCTUATION_MARKS = [',', '.', '!', '?'];
    const PUNCTUATION_MARKS_LARGE = ['.', '!', '?'];
    const ALL_MARKS = [',', '.', '!', '?', SPACE];

    function DEFAULT_DATA() {
        return {
            selectedPunctuationMark: ',',
            amountClickAnswer: 0,
            showContinueButton: false,
            text: '',
            answers: {
                good: 0,
                bad: 0,
            },
            textArray: [],
            canClickReply: true,
            showAnswer: false,
        };
    }

    const capitalize = string => string[0].toUpperCase() + string.slice(1);

    export default {
        mixins: [playBoxGameMixin, olympiadRussianLanguageAnswerTimerMixin, Battle],
        components: { ScalingBar, CalculatingAnswers },
        data() {
            return Object.assign(
                {
                    fontSizeCoefficient: 2.5,
                    ALL_MARKS,
                    punctuationMarksLargeSet: new Set(PUNCTUATION_MARKS_LARGE),
                },
                DEFAULT_DATA()
            );
        },
        mounted() {
            document.addEventListener('keydown', this.handleKeyPress);
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this.handleKeyPress);
        },
        computed: {
            chunkedTextArray() {
                return chunk(this.textArray, 2);
            },
            hasErrors() {
                return this.textArray.some(({ error }) => error);
            },
            lowerCaseText() {
                const capitalizeWordsSet = new Set(this.parameters.sourceTextCapitalizeWords);
                return capitalize(
                    this.text
                        .replaceAll(/[\s]+/g, ' ')
                        .trim()
                        .split(' ')
                        .map(word => {
                            const wordWithoutPunctuation = word.replaceAll(/[,.?!]/g, '');
                            return capitalizeWordsSet.has(wordWithoutPunctuation) ? word : word.toLowerCase();
                        })
                        .join(' ')
                );
            },
        },
        methods: {
            handleKeyPress() {
                if (event.keyCode === 13 &&
                    !this.gameFinished &&
                    (this.canClickReply)
                ) {
                    return this.processReply();
                }
            },
            registerSounds() {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
                this.$createjs.Sound.alternateExtensions = ['mp3', 'ogg'];
                this.$createjs.Sound.registerSounds(this.soundObjects);
            },
            fetchData() {
                this.getExercise()
                    .then(() => {
                        this.text = this.parameters.sourceText;
                        this.computeTextArray();
                        this.startGame();
                        this.registerSounds();
                        this.isLoading = false;
                    })
                    .catch(e => {
                        console.error(e);
                        this.$toasted.error(this.$root.$t('errors.getting_level'));
                        this.$router.push({ name: 'dashboard' });
                    });
            },

            finishGame() {
                this.gameFinished = true;
                this.stopTimers();
                this.soundInstance = this.$createjs.Sound.play('gameDone');
                this.sendStat();
            },
            refreshGameStatBeforeSend() {
                this.gameStat.answers = this.answers.good;
                this.gameStat.amountOfMistakes = this.answers.bad;
                this.gameStat.attempts = 1;
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.amountOfExamples = this.parameters.amountOfExamples;
                this.gameStat.parameters = cloneDeep(this.parameters);
            },
            calculatePercent() {
                let total = this.answers.good + this.answers.bad;
                if (total > 0) {
                    return parseInt((this.answers.good / total) * 100);
                }
                return 0;
            },
            startGame() {
                this.gameStarted = true;
                this.startTimer();
            },
            startTimer() {
                this.startAnswerTimer();
                this.$nextTick(() => {
                    if (!this.timer) {
                        this.setTimer();
                    }
                });
            },
            beforeGameRestart() {
                Object.assign(this, DEFAULT_DATA());
            },
            clickSpace(item) {
                if (item.disabled || this.hasErrors || this.showAnswer) return;
                item.error = false;
                item.showAnswer = false;
                item.userAnswer =
                    item.userAnswer === this.selectedPunctuationMark ? SPACE : this.selectedPunctuationMark;
                this.canClickReply = true;
            },
            getUserAnswerWord(item, index) {
                return index < 1 || !this.punctuationMarksLargeSet.has(this.textArray[index - 1].userAnswer)
                    ? item.userAnswer
                    : capitalize(item.userAnswer);
            },
            showCorrectAnswers() {
                for (const item of this.textArray) {
                    if (item.disabled) continue;
                    if (item.answer !== item.userAnswer) {
                        item.showAnswer = true;
                        item.error = false;
                    }
                }
                this.showAnswer = true;
                this.stopTimers();
            },
            processFix() {
                this.textArray.forEach(item => {
                    if (item.error) {
                        item.userAnswer = '&nbsp;';
                        item.error = false;
                    }
                    item.showAnswer = false;
                });
                this.canClickReply = true;
            },
            processReply(finishExample = false) {
                this.canClickReply = false;
                this.amountClickAnswer++;
                for (const item of this.textArray) {
                    if (item.disabled) continue;
                    if (item.answer === item.userAnswer) {
                        if (item.type === 'punctuation_mark') {
                            item.disabled = true;
                            this.answers.good++;
                        }
                    } else {
                        this.answers.bad++;
                        item.error = true;
                    }
                }
                if (this.isOlympiad || this.isBattle || !this.textArray.some(({ error }) => error) || finishExample) {
                    this.finishGame();
                }
            },
            computeTextArray() {
                this.textArray = [];
                const punctuationMarksSet = new Set(PUNCTUATION_MARKS);
                let isPrevSymbolLetter = false;
                this.lowerCaseText.split('').forEach(symbol => {
                    if (punctuationMarksSet.has(symbol)) {
                        this.textArray.push({
                            type: 'punctuation_mark',
                            answer: symbol,
                            disabled: false,
                            showAnswer: false,
                            userAnswer: '&nbsp;',
                            error: false,
                        });
                        isPrevSymbolLetter = false;
                    } else if (symbol === ' ') {
                        this.textArray.push({
                            type: 'space',
                            answer: '&nbsp;',
                            disabled: false,
                            showAnswer: false,
                            userAnswer: '&nbsp;',
                            error: false,
                        });
                        isPrevSymbolLetter = false;
                    } else {
                        if (isPrevSymbolLetter) {
                            this.textArray.at(-1).answer += symbol;
                            this.textArray.at(-1).userAnswer += symbol;
                        } else {
                            this.textArray.push({
                                type: 'word',
                                answer: symbol,
                                disabled: true,
                                showAnswer: false,
                                userAnswer: symbol,
                                error: false,
                            });
                        }
                        isPrevSymbolLetter = true;
                    }
                });
                const indexesForRemoveSet = new Set([]);
                this.textArray.forEach((symbol, index) => {
                    if (index === 0 || index === this.textArray.length - 1) {
                        return;
                    }
                    if (symbol.type === 'punctuation_mark') {
                        if (this.textArray[index - 1].type === 'space') {
                            indexesForRemoveSet.add(index - 1);
                        }
                        if (this.textArray[index + 1].type === 'space') {
                            indexesForRemoveSet.add(index + 1);
                        }
                    }
                });
                this.textArray = this.textArray.filter((symbol, index) => {
                    return !indexesForRemoveSet.has(index);
                });
            },
            stopTimers() {
                this.stopTimer();
                this.stopAnswerTimer();
            },
            spaceClass({ disabled, error, showAnswer }) {
                const result = { error, success: showAnswer };
                if (disabled) {
                    result.disabled = true;
                }
                if (this.hasErrors || this.showAnswer) {
                    result.disabled = true;
                }
                return result;
            },
        },
    };
</script>

<style scoped lang="scss">
    @import '@/assets/sass/games/playbox.scss';
    .play-box__end-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .play-box__reaction-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        @include media($md) {
            flex-direction: row;
        }
    }

    .play-box__answers {
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
        @include media($md) {
            font-size: 22px;
            line-height: 26px;
        }
        @include media($lg) {
            font-size: 32px;
            line-height: 38px;
        }
        @include media($xl) {
            font-size: 42px;
            line-height: 50px;
        }
    }

    .play-box__image {
        max-width: 100%;
        margin-bottom: 30px;
        @include media($md) {
            margin-bottom: 40px;
        }
    }

    .play-box__game {
        display: flex;
        gap: 20px;
        flex-direction: column-reverse;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        @media screen and (min-width: 800px) {
            flex-direction: row;
            align-items: flex-start;
        }
    }

    .play-box__example {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .play-box__answer-buttons {
        display: flex;
        gap: 20px;
        justify-content: center;
        margin-top: 20px;
    }

    .play-box__field {
        padding: 0 20px;
        text-align: center;
        font-weight: bold;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        &-chunk {
            display: flex;
        }
        font-size: 7px;
        @include media($sm) {
            font-size: 8px;
        }
        @include media($md) {
            font-size: 9px;
        }
        @include media($lg) {
            font-size: 12px;
        }
        @include media($xl) {
            font-size: 14px;
        }
        @include media($xxl) {
            font-size: 16px;
        }
    }

    .play-box__marks {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: 20px;
        margin-top: 20px;

        font-size: 7px;
        @include media($sm) {
            font-size: 8px;
        }
        @include media($md) {
            font-size: 9px;
        }
        @include media($lg) {
            font-size: 12px;
        }
        @include media($xl) {
            font-size: 14px;
        }
        @include media($xxl) {
            font-size: 16px;
        }
    }

    .play-box__mark {
        width: 2.2em;
        height: 2em;
        text-align: center;
        font-weight: bold;
        border-radius: 4px;
        border-width: 3px;
        border-style: solid;
        line-height: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 100ms;
        &.selected {
            background: #2266ff;
            border-color: #2266ff;
            color: white;
        }
        &:not(.selected):hover {
            cursor: pointer;
            background: #93b3ff;
            border-color: #93b3ff;
        }
    }

    .play-box__mark-padding {
        padding-bottom: 0.5em;
    }

    .play-box__field-space {
        width: 1em;
        text-align: left;
        border-bottom-style: solid;
        border-bottom-width: 1px;
        border-bottom-color: transparent;
        &:not(.disabled):hover {
            border-radius: 4px;
            cursor: pointer;
            background: #00000026;
        }
        &.success {
            color: green;
            border-bottom-color: green;
        }
        &.error {
            color: red;
            border-bottom-color: red;
        }
    }

    .game-info__block {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        @media screen and (max-width: 800px) {
            &::v-deep .game-info {
                width: 100%;
            }
            &::v-deep .game-info__block {
                flex-direction: row;
                width: 100%;
                justify-content: space-between;
            }
        }
    }

    .play-box__answers--left {
        color: $hsl-color-green-58;
        margin-left: 20px;
        @include media($lg) {
            margin-left: 35px;
        }
    }

    .play-box__answers--right {
        color: $hsl-color-green-58;
        margin-right: 20px;
        @include media($lg) {
            margin-right: 35px;
        }
    }
</style>
